<template>
  <a-card title="国际化文案配置">
    <!-- <a-tabs v-model:activeKey="formSearch.region_code" @change="handleTableChange()" >
      <a-tab-pane key="" tab="全部"></a-tab-pane>
      <a-tab-pane key="lang_zh" tab="中文 zh"></a-tab-pane>
      <a-tab-pane key="lang_en" tab="英语 en"></a-tab-pane>
    </a-tabs>  -->
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
          <a-input placeholder="键值" v-model:value="formSearch.key" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="中文内容" v-model:value="formSearch.lang_zh" />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
    <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
      <template #operator_id="{ record }">
        <Username :user_id="record.operator_id" />
      </template>
      <template #created_at="{ record }">
       <div>创建时间: {{ record.created_at.toLocaleString() }}</div>
       <div>修改时间: {{ record.updated_at.toLocaleString() }}</div>
      </template>
     
      </a-table>
  </a-card>
  

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import Username from '@/components/Username.vue';

export default defineComponent({
  components: {
    SearchOutlined,
    Username,
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
       formSearch: {
        key: '',
        lang_zh: '',
        lang_en: '',
        lang_jp: '',
      },
      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  methods: {
    resetForm() {
      this.$refs.formRef.resetFields();
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/i18n/texts', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch
      })
      this.loading = false
      if (rsp.data.list == null) {
        this.noticeMessage = '暂无数据'
        this.dataSource = []
        return
      }
      for (let i = 0; i < rsp.data.list.length; i++) {
        rsp.data.list[i].created_at = new Date(rsp.data.list[i].created_at)
        rsp.data.list[i].updated_at = new Date(rsp.data.list[i].updated_at)
      }
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
        {
          title: '键值',
          dataIndex: 'uniq_key',
          key: 'uniq_key',
        },
        {
          title: '中文',
          dataIndex: 'lang_zh',
          key: 'lang_zh',
        },
        {
          title: '英文',
          dataIndex: 'lang_en',
          key: 'lang_en',
        },
        {
          title: '日文',
          dataIndex: 'lang_jp',
          key: 'lang_jp',
        },
        {
          title: '韩文',
          dataIndex: 'lang_kr',
          key: 'lang_kr',
        },
        {
          title: '泰文',
          dataIndex: 'lang_th',
          key: 'lang_th',
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          slots: { customRender: 'created_at' },
        },
      
        {
          title: '操作人',
          dataIndex: 'operator_id',
          key: 'operator_id',
          slots: { customRender: 'operator_id' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>